module.exports = __webpack_public_path__ + "static/CircularStd-BoldItalic-aabccd8319d7e5c84d6582eb656cb46c.ttf";